import request from '@/utils/request'

let Employment_typeApi = {

  /*用工类型列表*/
  list(data) {
    return request._post('/shop/plus.employment_type.Index/index', data);
},
/*添加用工类型*/
add(data) {
    return request._post('/shop/plus.employment_type.Index/add', data);
},
/*修改用工类型*/
edit(data) {
    return request._post('/shop/plus.employment_type.Index/edit', data);
},
/*删除用工类型*/
del(data) {
    return request._post('/shop/plus.employment_type.Index/del', data);
},
/*获取父级列表*/
getParents(data) {
    return request._post('/shop/plus.employment_type.Index/getParents', data);
},
/*树形列表*/
treeList(data) {
    return request._post('/shop/plus.employment_type.Index/treeList', data);
},
  /*新增：获取职位类型（parent_id > 0 的二级用工类型）*/
  getJobTypes(data) {
    return request._post('/shop/plus.employment_type.Index/getJobTypes', data);
  },
/*用工类型详情*/
detail(data) {
  return request._post('/shop/plus.employment_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.employment_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.employment_type.Setting/getSetting', data, errorback);
    },
}
export default Employment_typeApi;



// WEBPACK FOOTER //
// ./src/api/employment_type.js